module.exports = __webpack_public_path__ + "static/media/objects_23.988aa6db.svg";